import React from 'react';
import {format, parseISO} from 'date-fns';
import BookingDetailsLinkedVisitInfo from "./BookingDetailsLinkedVisitInfo";
import {getCustomFormValue} from "../../../Helpers/CustomFormHelper";
import AdditionalInformation
    from "../../../Components/Table/AdditionalInformation";
import { formatPrice } from "../../../Helpers/PaymentHelper";
import { BOOKINGS_API_URL } from "../Bookings";

const addCustomFormFieldValues = (data, formData, fields) => {
    const dontShowFormFieldTypes = ['image_upload', 'file_upload'];

    for (var i in fields) {
        const formField = fields[i];

        if (!formData.hasOwnProperty(formField.id)
            || dontShowFormFieldTypes.includes(formField.type)
        ) {
            continue;
        }

        // We don't need to iterate sub-form fields here as we're receiving
        // flattened data & fields from the server

        data.push({
            field: formField?.label ?? '',
            value: getCustomFormValue(formField, formData)
        })
    }
}

const BookingDetailsList = (props) => {
    const data = [
        {
            field: 'Notes',
            value: props.data.notes
        },
    ]

    // Add an extra field to display details of linked visit
    if (props.data.visitors && props.data.visitors.length) {
        data.push({
            field: 'Additional visitors',
            value: <BookingDetailsLinkedVisitInfo booking={props.data}/>
        })
    }

    if(props.data.visitors_notes) {
        data.push({
            field: 'Notes for reception',
            value: props.data.visitors_notes
        });
    }

    if (props.data.signed_in_at) {
        data.push({
            field: 'Signed In',
            value: format(parseISO(props.data.signed_in_at), 'dd/MM/yyyy HH:mm'),
        });

        data.push({
            field: 'Signed In By',
            value: props.data.signed_in_by_user.fullname ?? null,
        });
    }


    if (props.data.booked_config.searched_at_sign_in_enabled) {
        if (props.data.was_searched) {
            data.push({
                field: 'Searched at',
                value: format(parseISO(props.data.signed_in_at), 'dd/MM/yyyy HH:mm'),
            });
        }

        data.push({
            field: 'Search Notes',
            value: props.data.search_notes
        });
    }

    if (props.data.signed_out_at) {
        data.push({
            field: 'Signed Out',
            value: format(parseISO(props.data.signed_out_at), 'dd/MM/yyyy HH:mm'),
        });

        data.push({
            field: 'Signed Out By',
            value: props.data.signed_out_by_user.fullname ?? null
        });
    }

    if (props.data.form && props.data.formConfig && props.data.formConfig.fields && props.data.formConfig.fields.length) {
        addCustomFormFieldValues(data, props.data.form, props.data.formConfig.fields);
    }

    if (props.data.payment) {
        if (props.data.payment.confirmed_at) {
            const payment = props.data.payment;

            data.push({
                field: 'Paid',
                value: formatPrice(payment.total_amount, payment.currency_symbol)
            });

            data.push({
                field: 'Payment Reference',
                value: `${payment.reference} (${format(parseISO(payment.confirmed_at), 'dd/MM/yyyy HH:mm')})`
            });

            data.push({
                field: 'Invoice',
                value: <span><a href={`${BOOKINGS_API_URL}payment/receipt/${props.data.id}`} target="_blank">Click to view</a></span>
            });

            if (payment.cancellable_until) {
                data.push({
                    field: 'Cancellable before',
                    value: format(parseISO(payment.cancellable_until), 'dd/MM/yyyy HH:mm')
                })
            }
        } else {
            data.push({
                field: 'Not yet paid',
                value: formatPrice(payment.total_amount, payment.currency_symbol)
            });
        }

        if (props.data.payment.refund) {
            data.push({
                field: 'Refunded at',
                value: props.data.payment.refund.confirmed_at
            });
        }
    }

    if (props.data.archived_at) {
        data.push({
            field: 'Cancelled At',
            value: format(parseISO(props.data.archived_at), 'dd/MM/yyyy HH:mm'),
        });

        data.push({
            field: 'Cancelled By',
            value: (props.data.archiver) ? props.data.archiver.fullname : 'Cancelled by System'
        });
    }

    return <AdditionalInformation
        data={data}
        datatableHack={props.datatableHack}
    />
}

BookingDetailsList.defaultProps = {
    datatableHack: true
}

export default BookingDetailsList;

